import { useLocation } from 'react-router-dom';
import { Login } from './components/Login';
import { AppRoutes } from './app/AppRoutes';
import { useAuth } from './providers/AuthProvider';
import { LegalPage } from './pages/LegalPage';

export default function App() {
  const { pathname } = useLocation();
  const { isLoading, isAuthenticated, refreshSession } = useAuth();

  if (pathname === '/terms' || pathname === '/terms/') return <LegalPage type="terms" />;
  if (pathname === '/privacy' || pathname === '/privacy/') return <LegalPage type="privacy" />;

  if (isLoading) return <div className="min-h-screen bg-gray-50 flex items-center justify-center"><div className="animate-spin size-8 border-2 border-blue-600 border-t-transparent rounded-full" /></div>;
  if (!isAuthenticated) return <Login onLogin={refreshSession} />;
  return <AppRoutes />;
}
